<template lang="pug">
  .finish
    component(:is="gameComponent" :login="user.full_name" :token="token" server="production" @gameEnd="closeModal" :match="tournamentId")
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  props: {
    tournamentId: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      gameComponent: null
    }
  },

  computed: {
    ...mapState('user', ['user', 'token'])
  },

  async mounted () {
    const { FlappyBird } = await import('@vvvgames/flappybird-vue2')
    this.gameComponent = FlappyBird
  },

  methods: {
    ...mapMutations('modal', ['toggle']),

    closeModal () {
      console.log('close flappy')
      this.toggle(false)
    }
  }
}
</script>

<style lang="scss">
.finish {
  width: 100%;
}

.modal.modal--modalflappygame {
  display: flex;
  min-width: 328px;
  max-width: 910px !important;
  padding: 0 !important;
  height: 85vh;
}
</style>
